import React from 'react';
import { Form, InputField } from 'components/Form';
import { Dialog, DialogTitle } from 'components/Elements';
import { AtSign, User, X } from 'react-feather';
import { useMutation } from 'react-query';
import { joinWaitlist } from '../api/joinWaitlist';
import Lottie from 'lottie-react';
import checkAnimation from 'assets/check.json';

export const JoinWaitList = () => {
  const [show, setShow] = React.useState(false);
  const [isSuccess, setIsSuccess] = React.useState(false);

  const joinWaitlistMutation = useMutation(joinWaitlist, {
    onSuccess: () => {
      setIsSuccess(true);
    },
    onError: (error) => {
      console.error('Error joining waitlist: ', error);
    },
  });

  const handleClose = () => {
    setShow(false);
    setIsSuccess(false);
  };

  const handleOpen = () => setShow(true);

  return (
    <div className="flex justify-center items-center">
      <button
        onClick={handleOpen}
        className="bg-[#232323] text-white text-lg px-6 py-2 rounded-full hover:bg-gray-800 transition"
      >
        Join waitlist
      </button>
      <Dialog isOpen={show} onClose={handleClose} initialFocus={null}>
        <div className="inline-block align-bottom bg-[#26C4FF] dark:bg-gray-900 dark:text-gray-100 rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <DialogTitle className="flex justify-between items-center mb-4">
            <span className="text-xl font-bold text-white">
              {isSuccess ? 'Success' : 'Join Our Waitlist'}
            </span>
            <button onClick={handleClose} className="bg-blue-100 text-[#26C4FF] rounded-full p-2">
              <X />
            </button>
          </DialogTitle>
          {isSuccess ? (
            <div className="text-center">
              <Lottie animationData={checkAnimation} loop={false} className="w-32 h-32 mx-auto" />
              <p className="mt-4 text-3xl text-white">Thank you!</p>
              <p className="mt-4 text-lg text-white">
                You have been added to the waitlist. You'll be notified as soon as any of our
                features is available for you to test on the mobile app.
              </p>
            </div>
          ) : (
            <>
              <p className="mb-6 text-center text-white">
                Join our waitlist and get notified once our mobile app is fully available.
              </p>
              <Form
                id="join-waitlist"
                onSubmit={async (values) => {
                  try {
                    await joinWaitlistMutation.mutateAsync({ data: values });
                  } catch (error) {
                    console.error(error);
                  }
                }}
              >
                {({ register }) => (
                  <>
                    <InputField
                      name="name"
                      placeholder="Enter your full name"
                      required
                      icon={<User className="text-[#94e3ff]" />}
                      className="bg-[#26C4FF] border border-[#94e3ff] text-white placeholder-white text-center"
                      registration={register('name', { required: true })}
                    />
                    <InputField
                      name="email"
                      type="email"
                      placeholder="Valid Email Address"
                      required
                      icon={<AtSign className="text-[#94e3ff]" />}
                      className="bg-[#26C4FF] border border-[#94e3ff] text-white placeholder-white text-center"
                      registration={register('email', { required: true })}
                    />
                    <button
                      type="submit"
                      className="w-full bg-[#232323] text-white py-4 mt-4 rounded-full hover:bg-gray-800 transition"
                    >
                      {joinWaitlistMutation.isLoading ? 'Joining...' : 'Join Now'}
                    </button>
                  </>
                )}
              </Form>
            </>
          )}
        </div>
      </Dialog>
    </div>
  );
};
